<!-- components/IframeComponent.vue -->
<template>
  <div v-show="visible" class="iframe-container">
    <!-- <div class="iframe-btn"></div> -->
    <div @click="hiddenIframe" class="iframe-btn">
      <svg data-v-b3416dde="" width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="text-black-900"><path d="m4.397 4.554.073-.084a.75.75 0 0 1 .976-.073l.084.073L12 10.939l6.47-6.47a.75.75 0 1 1 1.06 1.061L13.061 12l6.47 6.47a.75.75 0 0 1 .072.976l-.073.084a.75.75 0 0 1-.976.073l-.084-.073L12 13.061l-6.47 6.47a.75.75 0 0 1-1.06-1.061L10.939 12l-6.47-6.47a.75.75 0 0 1-.072-.976l.073-.084-.073.084Z" fill="currentColor"></path></svg>
    </div>
    <iframe class="styled-iframe" id="inlineFrameExample" title="Inline Frame Example" width="400" height="640" :src="iframeSrc" style="
    border-radius: 20px;
    box-shadow: aliceblue;
    ">
    </iframe>
    <!-- <button @click="hiddenIframe" class="woot-elements--right woot-widget-bubble woot--close" style="background: rgb(0, 156, 224);"></button> -->
  </div>
</template>

<script>
import { useDarkMode } from 'widget/composables/useDarkMode';

export default {
  name: 'IframeComponent',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    iframeSrc: {
      type: String,
      default: window?.chatwootConfig?.chatFrontUrl,
    }
  },
  setup() {
    const { getThemeClass } = useDarkMode();
    return { getThemeClass };
  },
  watch: {
    visible(newVal) {
      console.log('IframeComponent - visible changed:', newVal);
    }
  },
  methods: {
    hiddenIframe() {
      this.$store.dispatch('accounts/toggleIframeVisible');
    }
  }
};
</script>

<style scoped>
.iframe-container {
  position: absolute;
  right: 20px;
  bottom: 106px;
  z-index: 10;
}

.iframe-btn {
  position: absolute;
  right: 20px;
  top: 24px;
  z-index: 15;
  height: 60px;
  /* width: 200px; */
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  /* background-color: #fff;
  background-color: rgb(249,249,251); */
}

.styled-iframe {
  border-radius: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2); /* 轻微阴影 */
  border: none;
}

.woot-widget-bubble.woot-elements--right {
  left: 330px;
  bottom: 60px;
}

.woot-widget-bubble:hover {
  background: #1f93ff;
  box-shadow: 0 8px 32px rgba(0, 0, 0, .4) !important;
}

.woot-widget-bubble svg {
  all: revert;
  height: 24px;
  margin: 20px;
  width: 24px;
}

.woot-widget-bubble.woot-widget-bubble-color--lighter path{
  fill: var(--s-700);
}

@media only screen and (min-width: 667px) {
  .woot-widget-holder.woot-elements--left {
    left: 20px;
 }
  .woot-widget-holder.woot-elements--right {
    right: 20px;
 }
}

.woot--close:hover {
  opacity: 1;
}

.woot--close::before, .woot--close::after {
  background-color: #fff;
  content: ' ';
  display: inline;
  height: 24px;
  left: 32px;
  position: absolute;
  top: 20px;
  width: 2px;
}

.woot-widget-bubble-color--lighter.woot--close::before, .woot-widget-bubble-color--lighter.woot--close::after {
  background-color: var(--s-700);
}

.woot--close::before {
  transform: rotate(45deg);
}

.woot--close::after {
  transform: rotate(-45deg);
}
</style>
